import { Fragment } from "react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import clsx from "clsx"
import Button from "@/components/Button"
import { useGame } from "@/hooks/useGame"
import downloadPgn from "@/utils/downloadPgn"
import getGameTitle from "@/utils/getGameTitle"
import { Modals, useModals } from "@/hooks/useModals"
import useDeleteGame from "@/hooks/useDeleteGame"

const ActionsDropdown = () => {
  const { openModal } = useModals()
  const { deleteGame, processing } = useDeleteGame()
  const { id, initialGame } = useGame()

  const handleDownloadPgn = () => {
    const gameTitle = getGameTitle(initialGame)

    downloadPgn([initialGame], gameTitle)
  }

  const handleDeleteGame = async () => {
    const confirmation = confirm("Are you sure you want to delete this game?")

    if (!confirmation) return

    deleteGame(id)
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton as={Fragment}>
          <Button
            size="sm"
            disabled={processing}
            loading={processing}
            style="secondary"
          >
            <span className="sr-only">Options</span>
            <ChevronDownIcon
              className="ui-open:rotate-180 h-5 w-5 transition-transform duration-100 ease-out"
              aria-hidden="true"
            />
          </Button>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className={clsx([
          "absolute left-0 z-10 mt-2 w-36 origin-top-left overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none sm:right-0 sm:origin-top-right",
          "data-closed:scale-95 data-closed:opacity-0",
          "data-enter:duration-100 data-enter:ease-out",
          "data-leave:duration-75 data-leave:ease-in",
        ])}
      >
        <div className="py-2">
          <MenuItem>
            <button
              onClick={handleDownloadPgn}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Download PGN
            </button>
          </MenuItem>
          <MenuItem>
            <button
              disabled={processing}
              onClick={handleDeleteGame}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Delete game
            </button>
          </MenuItem>
          <MenuItem>
            <button
              onClick={() => openModal(Modals.EmbedGame)}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Embed game
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}

export default ActionsDropdown
